import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from '../../App';
import BackButton from '../../components/common/BackButton/BackButton';
import { getSettings } from '../../services/settingsCache';

export default function FAQ() {
  const { isNightMode } = useTheme();
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadSettings = async () => {
      try {
        setIsLoading(true);
        const data = await getSettings();
        if (!cancelled) {
          setSettings(data || null);
          setError('');
        }
      } catch (err) {
        if (!cancelled) {
          setError('Unable to load FAQs right now.');
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    loadSettings();

    return () => {
      cancelled = true;
    };
  }, []);

  const faqs = Array.isArray(settings?.contactFaqItems) ? settings.contactFaqItems : [];

  return (
    <main
      style={{
        background: isNightMode ? '#020617' : '#f8faf8',
        minHeight: 'calc(100vh - 200px)',
        padding: '60px 20px',
      }}
    >
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ marginBottom: 16 }}>
          <BackButton fallbackTo="/" />
        </div>

        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <span
            style={{
              display: 'inline-block',
              background: '#E6F4EA',
              color: '#3C7F39',
              padding: '6px 12px',
              fontSize: '0.85rem',
              borderRadius: '6px',
              marginBottom: 12,
            }}
          >
            {settings?.contactFaqBadge || 'FAQ'}
          </span>
          <h1
            style={{
              fontSize: '2.2rem',
              margin: '8px 0 10px',
              color: isNightMode ? '#f1f5f9' : '#111827',
            }}
          >
            {settings?.contactFaqTitle || 'Frequently Asked Questions'}
          </h1>
          <p style={{ color: isNightMode ? '#cbd5e1' : '#556', margin: 0 }}>
            {settings?.contactFaqSubtitle || 'Quick answers to common questions.'}
          </p>
        </div>

        {isLoading && <p style={{ textAlign: 'center' }}>Loading FAQs...</p>}
        {error && <p style={{ textAlign: 'center', color: '#dc2626' }}>{error}</p>}
        {!isLoading && !error && faqs.length === 0 && (
          <p style={{ textAlign: 'center', color: '#6b7280' }}>No FAQs available right now.</p>
        )}

        {faqs.map((item, idx) => (
          <div
            key={`${item.q}-${idx}`}
            style={{
              background: isNightMode ? '#1e293b' : '#fff',
              padding: '22px',
              borderRadius: '12px',
              boxShadow: isNightMode
                ? '0 6px 18px rgba(0,0,0,0.3)'
                : '0 6px 18px rgba(0,0,0,0.06)',
              maxWidth: 900,
              margin: '0 auto 16px',
            }}
          >
            <h2
              style={{
                marginBottom: 8,
                fontSize: '1.05rem',
                color: isNightMode ? '#f1f5f9' : '#111827',
              }}
            >
              {item.q}
            </h2>
            <p style={{ margin: 0, color: isNightMode ? '#cbd5e1' : '#555', lineHeight: 1.6 }}>
              {item.a}
            </p>
          </div>
        ))}

        <div style={{ textAlign: 'center', marginTop: 26 }}>
          <NavLink
            to="/contact"
            style={{
              display: 'inline-block',
              padding: '10px 16px',
              borderRadius: 10,
              background: isNightMode ? '#0f172a' : '#ffffff',
              color: '#4A6640',
              textDecoration: 'none',
              fontWeight: 700,
              border: isNightMode ? '1px solid #334155' : '1px solid #e5e7eb',
            }}
          >
            Contact Us
          </NavLink>
        </div>
      </div>
    </main>
  );
}
